import React, { useState, useEffect, useRef } from "react";
import AsyncSelect from "react-select/async";
import { customFetch } from '../apiClient';
import BatchDropdown from '../components/BatchDropdown'; 

const customStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    backgroundColor: "white",
    color: "black",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#ddd" : "white",
    color: "black",
  }),
};

// ✅ UPDATED: Removed free qty fields
function initItem() {
  return {
    medID: null,
    medicineName: "",
    category: "",
    companyName: "",
    packSize: "",
    unit: "",
    medicinecomposition: "",
    entryDate: new Date().toISOString().slice(0, 10),
    mrp: "",
    qty: "",
    pRate: "",
    gstP: "",
    hsnCode: "",
    mfgDate: "",
    expDate: "",
    batchNo: "",
    availableQty: 0,
    piece: "",
    leaf: "",
    dis: "",
    cd: "",
    cdInDis: "",
    taxable: 0,
    gstAmt: 0,
    totals: 0,
  };
}

const round2 = (v) => (Number.isFinite(v) ? parseFloat(v.toFixed(2)) : 0);
const getToken = () => sessionStorage.getItem("token") || "";

const DebitVoucher = () => {
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [items, setItems] = useState([]);
  const [currentItem, setCurrentItem] = useState(initItem());

  const [batchOptions, setBatchOptions] = useState([]);
  const [loadingBatches, setLoadingBatches] = useState(false);

  const [billDate, setBillDate] = useState(
    () => new Date().toISOString().slice(0, 10)
  );
  const [billNo, setBillNo] = useState("");
  const [remarks, setRemarks] = useState("");
  const [transport, setTransport] = useState("");
  const [headerCD, setHeaderCD] = useState(0);

  const [totals, setTotals] = useState({
    totalTaxable: 0,
    totalGst: 0,
    totalAmount: 0,
  });

  const [frid] = useState(1);
  const [hid] = useState(1);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const formRef = useRef(null);
  const medicineSelectRef = useRef(null);
  const batchDropdownRef = useRef(null);
  const leafInputRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      const firstInput = formRef.current?.querySelector(
        'select, input:not([type="hidden"]), .react-select__input input'
      );
      if (firstInput) firstInput.focus();
    }, 300);
  }, []);

  const handleKeyDown = (e) => {
    const isInsideAsyncSelect = 
      e.target.closest('.react-select__control') ||
      e.target.classList?.contains('react-select__input');
    
    if (isInsideAsyncSelect && e.key === 'Enter') {
      return;
    }

    const isReactSelectMenuOpen = document.querySelector('.react-select__menu');
    if (isReactSelectMenuOpen) return;

    const activeBatchDropdown = e.target.closest('[data-batch-dropdown="true"]');
    if (activeBatchDropdown) return;

    const batchPanelOpen = document.querySelector('.batch-dropdown-panel');
    if (batchPanelOpen) return;

    const focusableElements = formRef.current?.querySelectorAll(
      'input:not([disabled]):not([readonly]):not([type="hidden"]):not([tabindex="-1"]), ' +
      '.react-select__input input:not([disabled]):not([readonly]):not([type="hidden"]), ' +
      'select:not([disabled]):not([tabindex="-1"]), ' +
      'textarea:not([disabled]):not([readonly]), ' +
      'button:not([disabled]):not([tabindex="-1"])'
    );

    if (!focusableElements || focusableElements.length === 0) return;
    const currentIndex = Array.from(focusableElements).indexOf(e.target);

    const isAddButton = 
      e.target.textContent?.includes("Add Medicine") ||
      e.target.classList?.contains('add-medicine-btn') ||
      e.target.closest('button')?.textContent?.includes("Add Medicine");

    if (e.key === "Tab") {
      return;
    }

    if (e.key === "Enter") {
      if (isAddButton) {
        e.preventDefault();
        handleAddItem();
        return;
      }

      if (currentIndex === focusableElements.length - 1) {
        e.preventDefault();
        e.target.closest("form").requestSubmit();
        return;
      }

      e.preventDefault();
      const nextIndex = Math.min(focusableElements.length - 1, currentIndex + 1);
      focusableElements[nextIndex]?.focus();
    }
  };

  useEffect(() => {
    const handler = (e) => {
      if (formRef.current && e.target.closest("form") === formRef.current) {
        handleKeyDown(e);
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [handleKeyDown]);

  const loadVendorOptions = async (inputValue) => {
    if (!inputValue) return [];
    try {
     const res = await customFetch(`/VendorDT/search?name=${encodeURIComponent(inputValue)}`);
      if (!res.ok) return [];
      const data = await res.json();
      return data.map((v) => ({
        value: v.vid,
        label: `${v.vendorName} (${v.gstin || "No GST"})`,
        data: v,
      }));
    } catch {
      return [];
    }
  };

  const handleVendorChange = (selected) => {
    if (!selected) {
      setSelectedVendor(null);
      return;
    }
    setSelectedVendor(selected.data);
  };

  const loadMedicineOptions = async (inputValue) => {
    if (!inputValue) return [];
    try {
    const res = await customFetch(`/MedicineDT/search?medicine=${encodeURIComponent(inputValue)}`);
      if (!res.ok) return [];
      const data = await res.json();
      return data.map((m) => ({
        value: m.medID,
        label: m.medicine,
        data: m,
      }));
    } catch {
      return [];
    }
  };

  const loadBatchNumbers = async (medID) => {
    if (!medID) return;

    setLoadingBatches(true);
    try {
    const res = await customFetch(`/MedicineBatch/batches/${medID}?hid=${hid}&frid=${frid}`);
      if (!res.ok) {
        setBatchOptions([]);
        return;
      }

      const data = await res.json();
      const options = data.map((batch) => ({
        value: batch.batchNo,
        label: `${batch.batchNo} | Avail: ${batch.balance}`,
        balance: batch.balance,
        purchase: batch.purchase,
        sale: batch.sale,
        debitQty: batch.debitQty || 0,
        expDate: batch.expDate,
        mrp: batch.mrp,
        sRate: batch.sRate,
      }));

      setBatchOptions(options);
    } catch {
      setBatchOptions([]);
    } finally {
      setLoadingBatches(false);
    }
  };

  const handleMedicineChange = async (selected) => {
    if (!selected) {
      setCurrentItem(initItem());
      setBatchOptions([]);
      return;
    }

    const m = selected.data;
    setCurrentItem((prev) => ({
      ...prev,
      medID: m.medID,
      medicinecomposition: m.mediInUnit,
      medicineName: m.medicine,
      category: m.categoryName,
      companyName: m.brandName,
      packSize: m.iUnit,
      unit: m.mUnit,
      gstP: m.gstp || "",
      mrp: m.mrp || "",
      hsnCode: m.hsncode || "",
      batchNo: "",
      availableQty: 0,
      expDate: "",
    }));

    setError("");
    setSuccess("");

    await loadBatchNumbers(m.medID);

    setTimeout(() => {
      if (batchDropdownRef.current) {
        batchDropdownRef.current.focus();
      }
    }, 200);
  };

  const handleBatchSelectCustom = (batch) => {
    if (!batch) {
      setCurrentItem((prev) => ({
        ...prev,
        batchNo: "",
        availableQty: 0,
        expDate: "",
      }));
      return;
    }

    setCurrentItem((prev) => ({
      ...prev,
      batchNo: batch.value,
      availableQty: batch.balance,
      expDate: batch.expDate,
    }));
    
    setTimeout(() => {
      if (leafInputRef.current) {
        leafInputRef.current.focus();
        leafInputRef.current.select();
      }
    }, 100);
  };

  // ✅ UPDATED: No free qty calculation
  const recalcItem = (item) => {
    const packSize = parseFloat(item.packSize) || 1;
    const leaf = parseFloat(item.leaf) || 0;
    const piece = parseFloat(item.piece) || 0;

    const totalPcs = leaf * packSize + piece;
    item.qty = round2(totalPcs);

    const pRateLeaf = parseFloat(item.pRate) || 0;
    const gstPercent = parseFloat(item.gstP) || 0;
    const disPercent = parseFloat(item.dis) || 0;

    const pieceRate = packSize > 0 ? pRateLeaf / packSize : 0;
    const grossAmount = totalPcs * pieceRate;
    const disAmount = (grossAmount * disPercent) / 100;
    const taxable = grossAmount - disAmount;
    const gstAmt = (taxable * gstPercent) / 100;
    const lineTotal = taxable + gstAmt;

    item.taxable = round2(taxable);
    item.gstAmt = round2(gstAmt);
    item.totals = round2(lineTotal);
  };

  const applyItemChange = (item, name, value) => {
    const newItem = { ...item, [name]: value };
    recalcItem(newItem);
    return newItem;
  };

  const handleItemChange = (e) => {
    const { name, value } = e.target;
    const newItem = applyItemChange(currentItem, name, value);
    setCurrentItem(newItem);
  };

  const handleAddItem = () => {
    if (!currentItem.medID) {
      setError("Please select a medicine.");
      return;
    }

    if (!currentItem.batchNo) {
      setError("Please select a batch number.");
      return;
    }

    if (!currentItem.qty || Number(currentItem.qty) <= 0) {
      setError("Quantity must be greater than 0.");
      return;
    }

    if (Number(currentItem.qty) > Number(currentItem.availableQty)) {
      setError(
        `Cannot return ${currentItem.qty} pieces. Only ${currentItem.availableQty} available in batch ${currentItem.batchNo}.`
      );
      return;
    }

    setError("");
    setSuccess("");

    setItems((prev) => [currentItem, ...prev]);
    setCurrentItem(initItem());
    setBatchOptions([]);

    setTimeout(() => {
      if (medicineSelectRef.current) {
        medicineSelectRef.current.focus();
      }
    }, 150);
  };

  const handleRemoveItem = (index) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
  };

  const handleEditRowToForm = async (index) => {
    const row = items[index];
    if (!row) return;

    setCurrentItem(row);
    setItems((prev) => prev.filter((_, i) => i !== index));

    if (row.medID) {
      await loadBatchNumbers(row.medID);
    }

    setError("");
    setSuccess("");
  };

  useEffect(() => {
    const totalTaxable = items.reduce(
      (sum, it) => sum + (parseFloat(it.taxable) || 0),
      0
    );
    const totalGst = items.reduce(
      (sum, it) => sum + (parseFloat(it.gstAmt) || 0),
      0
    );
    const totalAmount = items.reduce(
      (sum, it) => sum + (parseFloat(it.totals) || 0),
      0
    );

    setTotals({
      totalTaxable: round2(totalTaxable),
      totalGst: round2(totalGst),
      totalAmount: round2(totalAmount),
    });
  }, [items]);

  const handleSave = async (e) => {
    e.preventDefault();

    if (!selectedVendor) {
      setError("Please select a Vendor.");
      return;
    }
    if (!billNo.trim()) {
      setError("Please enter Bill No.");
      return;
    }
    if (items.length === 0) {
      setError("At least add one medicine.");
      return;
    }

    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const token = getToken();
      const payload = {
        frid,
        hid,
        vendorId: selectedVendor.vid,
        billDate,
        billNo,
        remarks,
        transport,
        entryBy: null,
        cd: parseFloat(headerCD) || 0,
        items: items.map((it) => ({
          medID: it.medID,
          entryDate: it.entryDate,
          qty: parseFloat(it.qty) || 0,
          pRate: parseFloat(it.pRate) || 0,
          gstP: parseFloat(it.gstP) || 0,
          taxable: parseFloat(it.taxable) || 0,
          gstAmt: parseFloat(it.gstAmt) || 0,
          totals: parseFloat(it.totals) || 0,
          mrp: parseFloat(it.mrp) || 0,
          hsnCode: it.hsnCode || "",
          batchNo: it.batchNo || "",
          mfgDate: it.mfgDate || null,
          expDate: it.expDate || null,
          piece: it.piece ? parseInt(it.piece) : 0,
          leaf: it.leaf ? parseInt(it.leaf) : 0,
          dis: parseFloat(it.dis) || 0,
          cd: parseFloat(it.cd) || 0,
          cdInDis: parseFloat(it.cdInDis) || 0,
        })),
      };

   const res = await customFetch('/DebitVoucher/save', {
        method: "POST",
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || "Failed to save debit voucher.");
      }

      const data = await res.json();
      setSuccess(`Debit Voucher saved successfully. Bill No: ${data.billNo}`);
      setItems([]);
      setCurrentItem(initItem());
      setBatchOptions([]);
      setRemarks("");
      setTransport("");
      setHeaderCD(0);
      setBillNo("");
      setSelectedVendor(null);
    } catch (err) {
      setError(err.message || "Error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-0">
      <div className="card shadow">
        <div className="card-header bg-danger text-white py-2">
          <h6 className="mb-0 fw-bold">Debit Voucher (Return/Damage)</h6>
        </div>

        <div className="card-body fs-7">
          {error && <div className="alert alert-danger py-2">{error}</div>}
          {success && <div className="alert alert-success py-2">{success}</div>}

          <form ref={formRef} onSubmit={handleSave}>
            {/* Vendor Section */}
            <div className="border p-3 mb-3 rounded bg-light">
              <div className="row mb-1 mt-0">
                <div className="col-md-3">
                  <label className="form-label small mt-0 mb-0">
                    Search Vendor <span className="text-danger">*</span>
                  </label>
                  <AsyncSelect
                    cacheOptions
                    loadOptions={loadVendorOptions}
                    onChange={handleVendorChange}
                    placeholder="Type vendor name to search..."
                    isClearable
                    styles={customStyles}
                    value={
                      selectedVendor
                        ? {
                            value: selectedVendor.vid,
                            label: `${selectedVendor.vendorName} (${
                              selectedVendor.gstin || ""
                            })`,
                          }
                        : null
                    }
                  />
                </div>
                {selectedVendor && (
                  <>
                    <div className="col-md-2">
                      <label className="form-label small mb-0">Vendor Name</label>
                      <input
                        className="form-control form-control-sm"
                        value={selectedVendor.vendorName}
                        readOnly
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label small mb-0">GSTIN</label>
                      <input
                        className="form-control form-control-sm"
                        value={selectedVendor.gstin || ""}
                        readOnly
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label small mb-0">Mobile No</label>
                      <input
                        className="form-control form-control-sm"
                        value={selectedVendor.mobile || ""}
                        readOnly
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label small mb-0">Address</label>
                      <input
                        className="form-control form-control-sm"
                        value={selectedVendor.address || ""}
                        readOnly
                      />
                    </div>
                  </>
                )}
              </div>
              <div className="row">
                <div className="col-md-2">
                  <label className="form-label small mt-0 mb-0">
                    Bill No <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control form-control-sm"
                    value={billNo}
                    required
                    onChange={(e) => setBillNo(e.target.value)}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label small mt-0 mb-0">
                    Bill Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    required
                    className="form-control form-control-sm"
                    value={billDate}
                    onChange={(e) => setBillDate(e.target.value)}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label small mt-0 mb-0">Header CD</label>
                  <input
                    className="form-control form-control-sm"
                    value={headerCD}
                    onChange={(e) => setHeaderCD(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label small mt-0 mb-0">Transport</label>
                  <input
                    className="form-control form-control-sm"
                    value={transport}
                    onChange={(e) => setTransport(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label small mt-0 mb-0">Remarks</label>
                  <input
                    className="form-control form-control-sm"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Medicine Entry Section */}
            <div className="border p-2 mb-1 rounded">
              <div className="row mb-1">
                <div className="col-md-4">
                  <label className="form-label small mb-0 mt-0">
                    Search Medicine <span className="text-danger">*</span>
                  </label>
                  
                  <div onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      const menu = document.querySelector('.react-select__menu');
                      if (menu) {
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                      }
                      if (!currentItem.medID && items.length > 0) return;
                      if (currentItem.medID) return;
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }}>
                    <AsyncSelect
                      ref={medicineSelectRef}
                      cacheOptions
                      loadOptions={loadMedicineOptions}
                      onChange={handleMedicineChange}
                      placeholder="Start typing medicine name..."
                      isClearable
                      styles={customStyles}
                      value={
                        currentItem.medID
                          ? {
                              value: currentItem.medID,
                              label: currentItem.medicineName,
                            }
                          : null
                      }
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <label className="form-label small mb-0 mt-0">Composition</label>
                  <input
                    className="form-control form-control-sm"
                    value={currentItem.medicinecomposition}
                    readOnly
                  />
                </div>
                <div className="col-md-1">
                  <label className="form-label small mb-0 mt-0">Category</label>
                  <input
                    className="form-control form-control-sm"
                    value={currentItem.category}
                    readOnly
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label small mb-0 mt-0">Company</label>
                  <input
                    className="form-control form-control-sm"
                    value={currentItem.companyName}
                    readOnly
                  />
                </div>
                <div className="col-md-1">
                  <label className="form-label small mb-0 mt-0">Pack Size</label>
                  <input
                    className="form-control form-control-sm"
                    value={currentItem.packSize}
                    readOnly
                  />
                </div>
                <div className="col-md-1">
                  <label className="form-label small mb-0 mt-0">Unit</label>
                  <input
                    className="form-control form-control-sm"
                    value={currentItem.unit}
                    readOnly
                  />
                </div>
              </div>

              {currentItem.medID && (
                <>
                  <div className="row g-2 mb-1">
                    <div className="col-md-3">
                      <label className="form-label small mt-0 mb-0">
                        Batch No <span className="text-danger">*</span>
                      </label>
                      <BatchDropdown
                        ref={batchDropdownRef}
                        options={batchOptions}
                        value={currentItem.batchNo}
                        onChange={handleBatchSelectCustom}
                        loading={loadingBatches}
                        disabled={batchOptions.length === 0}
                      />
                    </div>

                    <div className="col-md-2">
                      <label className="form-label small mt-0 mb-0">Expiry Date</label>
                      <input
                        className="form-control form-control-sm bg-warning"
                        value={
                          currentItem.expDate
                            ? new Date(currentItem.expDate).toLocaleDateString("en-GB")
                            : ""
                        }
                        readOnly
                      />
                    </div>

                    <div className="col-md-2">
                      <label className="form-label small mt-0 mb-0">
                        Available Qty (To Return)
                      </label>
                      <input
                        className="form-control form-control-sm bg-info fw-bold"
                        value={currentItem.availableQty}
                        readOnly
                      />
                    </div>

                    <div className="col-md-2">
                      <label className="form-label small mt-0 mb-0">MRP</label>
                      <input
                        className="form-control form-control-sm"
                        value={currentItem.mrp}
                        readOnly
                      />
                    </div>

                    <div className="col-md-2">
                      <label className="form-label small mt-0 mb-0">GST %</label>
                      <input
                        className="form-control form-control-sm"
                        value={currentItem.gstP}
                        readOnly
                      />
                    </div>
                  </div>
                </>
              )}

              {currentItem.batchNo && (
                <>
                  <div className="row g-2 mb-1">
                    <div className="col-md-2">
                      <label className="form-label small mt-0 mb-0">Entry Date</label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        name="entryDate"
                        value={currentItem.entryDate}
                        onChange={handleItemChange}
                      />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label small mt-0 mb-0">Leaf</label>
                      <input
                        ref={leafInputRef} 
                        className="form-control form-control-sm"
                        name="leaf"
                        value={currentItem.leaf}
                        onChange={handleItemChange}
                      />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label small mt-0 mb-0">Piece</label>
                      <input
                        className="form-control form-control-sm"
                        name="piece"
                        value={currentItem.piece}
                        onChange={handleItemChange}
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label small mt-0 mb-0">
                        Pur. Rate <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control form-control-sm"
                        name="pRate"
                        value={currentItem.pRate}
                        onChange={handleItemChange}
                      />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label small mt-0 mb-0">Dis %</label>
                      <input
                        className="form-control form-control-sm"
                        name="dis"
                        value={currentItem.dis}
                        onChange={handleItemChange}
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label small mt-0 mb-0">HSN</label>
                      <input
                        className="form-control form-control-sm"
                        name="hsnCode"
                        value={currentItem.hsnCode}
                        onChange={handleItemChange}
                      />
                    </div>
                  </div>

                  <div className="row g-2 mb-1">
                    <div className="col-md-2">
                      <label className="form-label small mt-0 mb-0">Total Qty (Pcs)</label>
                      <input
                        className="form-control form-control-sm bg-info"
                        value={currentItem.qty}
                        readOnly
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label small mt-0 mb-0">Taxable</label>
                      <input
                        className="form-control form-control-sm"
                        value={currentItem.taxable}
                        readOnly
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label small mt-0 mb-0">GST Amt</label>
                      <input
                        className="form-control form-control-sm"
                        value={currentItem.gstAmt}
                        readOnly
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label small mt-0 mb-0">Amount</label>
                      <input
                        className="form-control form-control-sm bg-danger text-white fw-bold"
                        value={currentItem.totals}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleAddItem();
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            e.stopPropagation();
                            handleAddItem();
                          }
                        }}
                      >
                        Add Medicine
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* Items Table */}
            <div className="table-responsive mb-1 mt-0" style={{ fontSize: "0.8rem" }}>
              <table className="table table-sm table-bordered table-hover align-middle text-center">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Med Name</th>
                    <th>Batch No</th>
                    <th>Exp Date</th>
                    <th>Pack Size</th>
                    <th>Leaf</th>
                    <th>Piece</th>
                    <th>Total Pcs</th>
                    <th>Pur Rate</th>
                    <th>Dis %</th>
                    <th>GST %</th>
                    <th>Amount</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {items.length === 0 ? (
                    <tr>
                      <td colSpan="13" className="text-muted">
                        No items added.
                      </td>
                    </tr>
                  ) : (
                    items.map((it, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td className="text-start">{it.medicineName}</td>
                        <td>{it.batchNo}</td>
                        <td>
                          {it.expDate
                            ? new Date(it.expDate).toLocaleDateString("en-GB")
                            : ""}
                        </td>
                        <td>{it.packSize}</td>
                        <td>{it.leaf}</td>
                        <td>{it.piece}</td>
                        <td>{it.qty}</td>
                        <td>₹{Number(it.pRate || 0).toFixed(2)}</td>
                        <td>{Number(it.dis || 0).toFixed(2)}</td>
                        <td>{it.gstP}</td>
                        <td className="bg-danger text-white fw-bold">
                          ₹{Number(it.totals || 0).toFixed(2)}
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary me-1"
                            onClick={() => handleEditRowToForm(idx)}
                            tabIndex="-1"
                          >
                            ✏️
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => handleRemoveItem(idx)}
                            tabIndex="-1"
                          >
                            🗑️
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {items.length > 0 && (
              <div className="mt-1 p-2 border rounded bg-danger bg-opacity-10">
                <div className="row mb-0 mt-0">
                  <div className="col-md-2">
                    <label className="form-label small mt-0 mb-0">Total Taxable</label>
                    <input
                      className="form-control form-control-sm"
                      value={`₹${totals.totalTaxable.toFixed(2)}`}
                      readOnly
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label small mt-0 mb-0">Total GST</label>
                    <input
                      className="form-control form-control-sm"
                      value={`₹${totals.totalGst.toFixed(2)}`}
                      readOnly
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label small fw-bold mt-0 mb-0">
                      Total Amount
                    </label>
                    <input
                      className="form-control form-control-sm fw-bold bg-danger text-white"
                      value={`₹${totals.totalAmount.toFixed(2)}`}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="text-end mt-4">
              <button
                type="submit"
                className="btn btn-danger px-5"
                disabled={loading || items.length === 0 || !selectedVendor}
              >
                {loading ? "Saving..." : "Save Debit Voucher"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DebitVoucher;
